import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// actions
import * as Actions from 'actions';

// component
import WrapperSalesPage from '../component/WrapperSalesPage';

const mapStateToProps = state => ({
  app: state.app,
});

const mapDispatchToProps = dispatch => ({
  getGoalRevenues: (...args) => dispatch(Actions.getGoalRevenues(...args)),
});
class SalesPage extends Component {
  static propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    app: PropTypes.object,
    getGoalRevenues: PropTypes.func,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      reports: this.initReport(),
    };
    this.refresh([1, 2]);
  }

  initReport() {
    return (
      [
        {
          name: 'Goal Revenues Week',
        },
        {
          name: 'Goal Revenues Month',
        },
      ]
    );
  }

  refresh(key) {
    const { getGoalRevenues } = this.props;
    this.setState({ reports: this.initReport() });

    if (key.find(k => k === 1)) {
      getGoalRevenues('week').then(r => this.resolve(0, r));
    }
    if (key.find(k => k === 2)) {
      getGoalRevenues('month').then(r => this.resolve(1, r));
    }
  }

  resolve(index, r) {
    const { reports } = this.state;
    if (r.success) {
      reports[index].data = r.payload;
      this.setState({ reports });
    }
  }

  render() {
    const {
      location,
      history,
      app,
    } = this.props;

    const { reports } = this.state;


    return (
      <WrapperSalesPage
        history={history}
        location={location}
        reports={reports}
        key={app.currentSupervisor ? app.currentSupervisor.id : undefined}
      />
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(SalesPage);
